export const isNullish = <T>(value?: T | null): value is undefined | null =>
  value === null || value === undefined;
